/* Site-Specific JavaScript */
jq(document).ready(() => {
    const footnotes = new EqFootnote();

    const navigation = document.getElementById('corporate-nav');
    if (navigation) {
        const dropdowns = document.querySelectorAll('#corporate-nav > li.has-children');
        dropdowns.forEach((dropdown) => {
            const button = dropdown.querySelector('button');
            const menu = dropdown.querySelector('.dropdown');
            button.addEventListener('click', () => {
                if (!menu.classList.contains('active')) {
                    collapse_dropdowns(navigation);
                }
                const active = menu.classList.toggle('active');
                if (active) {
                    button.setAttribute('aria-expanded', 'true');
                } else {
                    button.setAttribute('aria-expanded', 'false');
                }
            });
        });
        jq(window).resize(() => {
            if (window.innerWidth < 768) {
                collapse_dropdowns(navigation);
            }
        });
        document.addEventListener('keydown', (evt) => {
            if (evt.key == 'Escape') {
                collapse_dropdowns(navigation);
            }
        });
    }
});
jq("#ketch_showexperience").on('click', function(e){
    e.preventDefault();
    ketch('showExperience');   
})
const collapse_dropdowns = (nav) => {
    if (!nav) {
        return;
    }
    const buttons = nav.querySelectorAll('li.has-children > button[aria-expanded="true"]');
    const dropdowns = nav.querySelectorAll('li.has-children > .dropdown.active');
    buttons.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
    });
    dropdowns.forEach((dropdown) => {
        dropdown.classList.remove('active');
    });
}